import { IEvent, MessageBus } from '@tom-ui/utils'
import { EventTypes } from '@yard/messages/eventsTypes'
import { HousekeepingPlanResponse } from '@yard/app/api'
import { BaseEntityStore } from './base/BaseEntityStore'

export class HousekeepingPlanStore extends BaseEntityStore<HousekeepingPlanResponse> {
  private readonly disposers: Array<() => void> = []

  constructor(private readonly messageBus: MessageBus) {
    super()

    this.disposers.push(
      this.messageBus.subscribeEvent<HousekeepingPlanResponse>(
        EventTypes.HousekeepingPlanUpsertedEvent,
        this.handleUpsertedEvent,
      ),
    )
  }

  dispose(): void {
    this.disposers.forEach(d => d())
    this.disposers.length = 0
  }

  private handleUpsertedEvent = (event: IEvent<HousekeepingPlanResponse>) => {
    const plan = event.payload
    if (!plan) return
    this.updateStoreItem(plan, plan.id)
  }
}
